// extracted by mini-css-extract-plugin
module.exports = {"labelHeader":"app-radio-buttons_labelHeader_kW-Ua","labelText":"app-radio-buttons_labelText_3NOAP"};